const FIRST_CATEGORY_TABLE_HEAD = {
  // 工厂MRO与设施设备
  FACTORY_MRO_AND_FACILITY: [
    { label: '主图片', prop: 'mainImage', slotColumn: true, slotName: 'mainImage' },
    { label: '产品名称', prop: 'productName', slotColumn: true, slotName: 'productName' },
    { label: '材质', prop: 'material' },
    { label: '规格型号', prop: 'specModel' },
    { label: '货期', prop: 'deliveryDays' },
    { label: '起订量', prop: 'miniOrderNum' },
    // { label: '付款方式', prop: 'payMethodName' },
    // { label: '税率', prop: 'taxRate' },
    { label: '供应商', prop: 'supplierName' },
    { label: '联系人', prop: 'contactName' },
    { label: '联系电话', prop: 'contactPhone' },
    { label: '更新时间', prop: 'updateDate', type: 'time', width: 140 }
  ],
  // 工程项目与行政
  EP_AND_ADMINISTRATION: [
    { label: '产品图片', prop: 'mainImage', slotColumn: true, slotName: 'mainImage' },
    { label: '产品名称', prop: 'productName', slotColumn: true, slotName: 'productName' },
    { label: '服务内容', prop: 'serviceContent' },
    { label: '规格/型号', prop: 'specModel' },
    { label: '材质', prop: 'material' },
    { label: '含税价格（元）', prop: 'includeTaxPrice' },
    // { label: '付款方式', prop: 'payMethodName' },
    // { label: '发票', prop: 'invoiceName' },
    // { label: '税率', prop: 'taxRate' },
    { label: '间采对接人', prop: 'purchaseContactPerson' },
    // { label: '是否签订框架协议', prop: 'hasFrameworkAgreementName', width: 150 },
    { label: '供应商', prop: 'supplierName' },
    { label: '联系人', prop: 'contactName' },
    { label: '联系电话', prop: 'contactPhone' },
    { label: '备注', prop: 'remark' },
    { label: '更新时间', prop: 'updateDate', type: 'time', width: 140 }
  ],
  // 线下类
  OFFLINE: [
    { label: '产品图片', prop: 'mainImage', slotColumn: true, slotName: 'mainImage' },
    { label: '项目名称', prop: 'productName', slotColumn: true, slotName: 'productName' },
    { label: '时间', prop: 'projectDate' },
    { label: '地点', prop: 'location' },
    // { label: '需求人', prop: 'demander' },
    // { label: '需求部门', prop: 'demanderDept' },
    { label: '项目预算', prop: 'budget' },
    // { label: '付款方式', prop: 'payMethodName' },
    // { label: '发票', prop: 'invoiceName' },
    // { label: '税率', prop: 'taxRate' },
    { label: '间采对接人', prop: 'purchaseContactPerson' },
    // { label: '是否签订框架协议', prop: 'hasFrameworkAgreementName', width: 150 },
    { label: '设计/执行单位', prop: 'supplierName' },
    { label: '联系人', prop: 'contactName' },
    { label: '联系电话', prop: 'contactPhone' },
    { label: '备注', prop: 'remark' },
    { label: '更新时间', prop: 'updateDate', type: 'time', width: 140 }
  ],
}
const SECOND_CATEGORY_TABLE_HEAD = {
  // IT配件
  IT_PART: [
    { label: '主图片', prop: 'mainImage', slotColumn: true, slotName: 'mainImage' },
    { label: '产品名称', prop: 'productName', slotColumn: true, slotName: 'productName' },
    { label: '规格/型号/配置', prop: 'parameters', width: 110 },
    { label: '含税价格（元）', prop: 'includeTaxPrice' },
    // { label: '付款方式', prop: 'payMethodName' },
    // { label: '发票', prop: 'invoiceName' },
    // { label: '税率', prop: 'taxRate' },
    { label: '间采对接人', prop: 'purchaseContactPerson' },
    // { label: '是否签订框架协议', prop: 'hasFrameworkAgreementName', width: 150 },
    { label: '供应商', prop: 'supplierName' },
    { label: '联系人', prop: 'contactName' },
    { label: '联系电话', prop: 'contactPhone' },
    { label: '备注', prop: 'remark' },
    { label: '更新时间', prop: 'updateDate', type: 'time', width: 140 }
  ],
  // IT服务
  IT_SERVICE: [
    { label: '产品名称', prop: 'productName', slotColumn: true, slotName: 'productName' },
    { label: '服务内容', prop: 'serviceContent' },
    { label: '最短服务周期', prop: 'shortestServicePeriod' },
    { label: '商务流程时间', prop: 'businessProcessTime' },
    { label: '含税价格（元）', prop: 'includeTaxPrice' },
    // { label: '付款方式', prop: 'payMethodName' },
    // { label: '发票', prop: 'invoiceName' },
    // { label: '税率', prop: 'taxRate' },
    { label: '间采对接人', prop: 'purchaseContactPerson' },
    // { label: '是否签订框架协议', prop: 'hasFrameworkAgreementName', width: 150 },
    { label: '供应商', prop: 'supplierName' },
    { label: '联系人', prop: 'contactName' },
    { label: '联系电话', prop: 'contactPhone' },
    { label: '备注', prop: 'remark' },
    { label: '更新时间', prop: 'updateDate', type: 'time', width: 140 }
  ],
  // 第三方检测、认证、备案
  THIRD_PARTY_SERVICE: [
    { label: '服务名称', prop: 'productName', slotColumn: true, slotName: 'productName' },
    { label: '服务周期', prop: 'servicePeriod' },
    { label: '是否有CNAS', prop: 'hasCnasName' },
    { label: '是否有CMA', prop: 'hasCmaName' },
    { label: '含税价格（元）', prop: 'includeTaxPrice' },
    { label: '样品量', prop: 'sampleAmout' },
    // { label: '付款方式', prop: 'payMethodName' },
    // { label: '发票', prop: 'invoiceName' },
    // { label: '税率', prop: 'taxRate' },
    { label: '间采对接人', prop: 'purchaseContactPerson' },
    // { label: '是否签订框架协议', prop: 'hasFrameworkAgreementName', width: 150 },
    { label: '供应商', prop: 'supplierName' },
    { label: '联系人', prop: 'contactName' },
    { label: '联系电话', prop: 'contactPhone' },
    { label: '备注', prop: 'remark' },
    { label: '更新时间', prop: 'updateDate', type: 'time', width: 140 }
  ],
  // 旅游服务
  TOURISM_SERVICE: [
    { label: '服务名称', prop: 'productName', slotColumn: true, slotName: 'productName' },
    { label: '服务内容', prop: 'serviceContent' },
    { label: '含税价格（元）', prop: 'includeTaxPrice' },
    // { label: '付款方式', prop: 'payMethodName' },
    // { label: '发票', prop: 'invoiceName' },
    // { label: '税率', prop: 'taxRate' },
    { label: '间采对接人', prop: 'purchaseContactPerson' },
    // { label: '是否签订框架协议', prop: 'hasFrameworkAgreementName', width: 150 },
    { label: '供应商', prop: 'supplierName' },
    { label: '联系人', prop: 'contactName' },
    { label: '联系电话', prop: 'contactPhone' },
    { label: '备注', prop: 'remark' },
    { label: '更新时间', prop: 'updateDate', type: 'time', width: 140 }
  ],
  // 其他服务
  OTHER_SERVICE: [
    { label: '服务名称', prop: 'productName', slotColumn: true, slotName: 'productName' },
    { label: '服务内容', prop: 'serviceContent' },
    { label: '含税价格（元）', prop: 'includeTaxPrice' },
    // { label: '付款方式', prop: 'payMethodName' },
    // { label: '发票', prop: 'invoiceName' },
    // { label: '税率', prop: 'taxRate' },
    { label: '间采对接人', prop: 'purchaseContactPerson' },
    // { label: '是否签订框架协议', prop: 'hasFrameworkAgreementName', width: 150 },
    { label: '供应商', prop: 'supplierName' },
    { label: '联系人', prop: 'contactName' },
    { label: '联系电话', prop: 'contactPhone' },
    { label: '备注', prop: 'remark' },
    { label: '更新时间', prop: 'updateDate', type: 'time', width: 140 }
  ],
  // 调研服务
  RESEARCH_SERVICE: [
    { label: '服务名称', prop: 'productName', slotColumn: true, slotName: 'productName' },
    { label: '服务内容', prop: 'serviceContent' },
    { label: '访谈场所地址', prop: 'interviewVenueAddress' },
    { label: '服务准备周期', prop: 'serviceReadyPeriod' },
    { label: '历史合作案例', prop: 'historicalCase' },
    { label: '历史合作需求人', prop: 'historicalDemander' },
    { label: '含税价格（元）', prop: 'includeTaxPrice' },
    // { label: '付款方式', prop: 'payMethodName' },
    // { label: '发票', prop: 'invoiceName' },
    // { label: '税率', prop: 'taxRate' },
    { label: '间采对接人', prop: 'purchaseContactPerson' },
    // { label: '是否签订框架协议', prop: 'hasFrameworkAgreementName', width: 150 },
    { label: '供应商', prop: 'supplierName' },
    { label: '联系人', prop: 'contactName' },
    { label: '联系电话', prop: 'contactPhone' },
    { label: '备注', prop: 'remark' },
    { label: '更新时间', prop: 'updateDate', type: 'time', width: 140 }
  ]
}
export {
  FIRST_CATEGORY_TABLE_HEAD,
  SECOND_CATEGORY_TABLE_HEAD
};